import type { MaybeRefOrGetter, Ref } from 'vue';
import { useOnOutsideEvent } from './useOnOutsideEvent';

/**
 * Attaches a `pointerdown` listener on `document` (capture phase) and
 * invokes `callback` when the event target is outside every element
 * in `excludeEls`.
 *
 * The listener is attached immediately if `isActive` already resolves to
 * `true`, follows its further changes, and is automatically removed on
 * scope disposal.
 *
 * @param callback - Called when a click outside the elements is detected.
 * @param excludeEls - Refs to elements that are considered "inside" areas.
 *                     Empty by default: every click triggers `callback`.
 * @param isActive - Reactive flag that drives listener lifecycle. Always active by default.
 */
export const useClickOutside = (
    callback: () => void,
    excludeEls: Ref<HTMLElement | null>[] = [],
    isActive: MaybeRefOrGetter<boolean> = true,
): void => {
    useOnOutsideEvent({
        eventTarget: document,
        eventName: 'pointerdown',
        callback,
        excludeEls,
        isActive,
    });
};
